import { styled } from "~/common/mui";
import Spinner from "~/common/components/Spinner/Spinner";
import ModalContainer from "~/common/components/ModalContainer";
import type * as React from "react";
import { useSelector } from "react-redux";
import { type RootState } from "~/app/store";
import { useTranslation } from "react-i18next";

const FullscreenLoaderOverlay = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  background: "rgba(255, 255, 255, 0.8)",
  zIndex: 1305,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "> *": {
    flex: "0 1 33.33333333%",
  },
}));

const FullscreenLoader: React.FC = () => {
  const msg = useSelector(selectLoaderMsg);
  const { t } = useTranslation();
  return (
    <ModalContainer>
      <FullscreenLoaderOverlay>
        <Spinner label={t(msg)} />
      </FullscreenLoaderOverlay>
    </ModalContainer>
  );
};

const selectLoaderMsg = (state: RootState) => state.cartPage.requestInFlightMessage;

export default FullscreenLoader;
